<template>
  <v-container fluid px-0 py-4 ma-0>
    <PageHeader :title="displayName" subtitle="Edit this team"></PageHeader>
    <v-container id="teamedit-main" class="pa-0 px-4 ma-0 fluid">
      <Loading :isLoading="isTeamLoading">
        <v-flex style="background-color:white;" class="pa-0 elevation-2 rounded-3 ">
          <v-tabs id="useredit-tabs" show-arrows color="white" slider-color="primary" grow>
            <v-tab ripple>Details</v-tab>
            <v-tab ripple>Members</v-tab>
            <v-tab-item>
              <v-divider></v-divider>
              <v-container fluid>
                <v-flex xs12 px-4 py-3 mb-3>
                  <v-layout wrap row>
                    <v-flex xs12>
                      <h2 class="primary--text pb-2">Team details</h2>
                    </v-flex>
                    <v-flex xs12 md6
                      :class="{ 'mt-3 pr-0 pb-4 ': $vuetify.breakpoint.smAndDown, 'mt-3 pr-4 pb-0': $vuetify.breakpoint.mdAndUp }">
                      <v-text-field id="teameditdetails-name-text" label="Team display name" v-model="displayName"
                        @keyup="changesMade = true" box>
                      </v-text-field>
                      <v-switch v-model="isCommsroomEnabled" color="secondary" label="Enable Commsroom"></v-switch>
                      <v-switch v-model="isMetricsEnabled" color="secondary" label="Enable Metrics"></v-switch>
                      <v-switch v-if="canToggleChat" v-model="isChatEnabled" color="secondary" label="Enable Chat"></v-switch>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-divider></v-divider>
              <v-container fluid>
                <v-layout class="on-white-background" wrap>
                  <v-flex xs12 px-4 py-3 mb-3>
                    <v-layout row wrap class="on-white-background">
                      <v-flex xs12>
                        <h2 class="primary--text pb-2">Current Members</h2>
                      </v-flex>
                      <v-layout wrap class="card-margin-fix">
                        <user-card v-for="(item, i) in members" :key="i" :cardContent="item" :cardIndex="i"
                          cardAction="remove">
                        </user-card>
                      </v-layout>
                    </v-layout>
                    <br>
                    <h2 class="primary--text pb-3 pt-2">Add new members</h2>
                    <v-layout wrap class="card-margin-fix on-white-background">
                      <user-card v-for="(item, i) in availableUsers" :key="i" :cardContent="item" :cardIndex="i"
                        cardAction="add">
                      </user-card>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </Loading>
    </v-container>
    <v-layout wrap row class="px-4 ">
      <v-btn id="teamedit-delete-btn" class="mt-4 ml-0" color="error" @click="ShowDeleteTeamDialog = true">
        <v-icon>delete</v-icon>
        &emsp;DELETE TEAM
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn id="teamedit-save-btn" class="mt-4" color="success" @click="updateTeam(true)">
        Save Changes
      </v-btn>
    </v-layout>
    <v-dialog v-model="ShowDeleteTeamDialog" id="teamedit-delete-dialog" width="400">
      <v-card class="pa-4">
        <v-card-title class="pa-0 pb-2">
          <h2>Delete Team</h2>
        </v-card-title>
        <v-card-text class="pa-0">
          <p>Are you sure you want to delete this team?</p>
        </v-card-text>
        <v-card-actions class="ma-0 pa-0 pt-1">
          <v-btn @click="deleteTeam" id="teamedit-delete-dialog-delete-btn" color="error">
            Yes, delete this team
          </v-btn>
          <v-btn @click="ShowDeleteTeamDialog = false" id="teamedit-delete-dialog-cancel-btn" color="secondary">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import "@/assets/styles/styles.css"
import { mapState } from "vuex"
import PageHeader from "@/components/PageHeader.vue"
import Loading from "@/components/shared/Loading.vue"
import UserCard from "@/components/Users/UserCard.vue"

export default {
  name: "team-edit",
  components: { Loading, UserCard, PageHeader },
  data: () => ({
    changesMade: false,
    ShowDeleteTeamDialog: false
  }),
  watch: {
    teamTab() { this.handleRouteChange(this.teamTab) }
  },
  computed: {
    canToggleChat() {
      const email = this.$store.state.currentUser && this.$store.state.currentUser.me && this.$store.state.currentUser.me.email
      return email && String(email).toLowerCase().endsWith("@caseblocks.com")
    },
    ...mapState({
      isTeamLoading: state => state.ui.loadingSelectedTeam,
      allUsers: state => state.users.all,
      team: state => state.teams.current.team,
      members: state => {
        if (state.users.all && state.teams.current.team.users) {
          return state.users.all.filter(user => state.teams.current.team.users.find(member => member.id === user.id))
        } else {
          return []
        }
      },
      availableUsers: state => {
        if (state.users.all && state.teams.current.team.users) {
          return state.users.all.filter(user => !state.teams.current.team.users.find(member => member.id === user.id))
        } else {
          return []
        }
      }
    }),
    displayName: {
      get() {
        if (this.team && this.team.displayName) {
          return this.team.displayName
        } else {
          return "Team"
        }
      },
      set(newName) {
        this.team.displayName = newName
      }
    },
    isCommsroomEnabled: {
      get() {
        if (this.team && this.team.commsEnabled) {
          return this.team.commsEnabled
        } else {
          return false
        }
      },
      set(enabled) {
        this.team.commsEnabled = enabled
      }
    },
    isMetricsEnabled: {
      get() {
        if (this.team && this.team.metricsEnabled) {
          return this.team.metricsEnabled
        } else {
          return false
        }
      },
      set(enabled) {
        this.team.metricsEnabled = enabled
      }
    },
    isChatEnabled: {
      get() {
        return this.team && this.team.chatEnabled
      },
      set(enabled) {
        this.team.chatEnabled = enabled
      }
    }
  },
  methods: {
    handleRouteChange(route) {
      if (!this.localUpdate) {
        switch (route) {
          case "members":
            this.tabModel = 1
            break
          default:
            this.tabModel = 0
        }
      }
      this.localUpdate = false
    },
    checkSaveDialog() {
      this.ShowSaveTeamDialog = this.changesMade
    },
    async deleteTeam() {
      this.ShowDeleteUserDialog = false
      await this.$store.dispatch("deleteTeam", this.team)
      await this.$store.dispatch('requestCurrentUser')
      this.$router.push({ name: "Teams" })
    },
    async updateTeam(shouldExit) {
      await this.$store.dispatch("updateTeam", this.team);
      this.changesMade = false
      this.ShowSaveTeamDialog = false
      if (shouldExit) {
        this.$router.push({ name: "Teams" })
      }
    },
    cancelEdit(shouldExit) {
      this.changesMade = false
      this.ShowSaveTeamDialog = false
      if (shouldExit) {
        this.$router.push({ name: "Teams" })
      }
    }
  }
}
</script>
